module.exports = __webpack_public_path__ + "media/images/brand/app_text_150-8beac965ff70de3bf4efc7850967e5fa.png";